var exports = {
  "root": "x620889e6--6b7519--root",
  "icon": "x620889e6--6b7519--icon",
};

module.exports = exports;
